import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import {
  addCargoData,
  deleteCargoData,
  fetchCargoListData,
  moveCargoData,
  updateCargoData,
} from "../thunks/cargoThunks";

import type { Operation } from "../../utils/types/cargo";

interface CargoState {
  operations: {
    [key: string]: Operation[] | undefined;
  } | null;
  loading: boolean;
  error: string | null;
}

const initialState: CargoState = {
  operations: null,
  loading: false,
  error: null,
};

const cargoSlice = createSlice({
  name: "cargo",
  initialState,
  reducers: {
    // clearCargoes(state) {
    //   state.operations = [];
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCargoListData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCargoListData.fulfilled, (state, action) => {
        state.loading = false;
        // if (!state.operations) {
        //   state.operations = {};
        // }
        // state.operations[action.payload[0]?.berthId] = action.payload || [];
        const { payload } = action;

        const { berthId } = payload;
        if (!berthId) {
          state.error = "Invalid berth ID";
          return;
        }

        if (!state.operations) {
          state.operations = {};
        }
        state.operations[berthId] = payload.data || [];
      })
      .addCase(fetchCargoListData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(updateCargoData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCargoData.fulfilled, (state, action) => {
        state.loading = false;
        // if (state.operations) {
        //   state.operations[action.payload.berthId] = (
        //     state.operations[action.payload.berthId] || []
        //   ).map((operation) => {
        //     if (operation.cargoId === action.payload?.data?.cargoId) {
        //       return { ...operation, ...action.payload?.data };
        //     }
        //     return operation;
        //   });
        // }

        const { payload } = action;
        if (!payload || !payload.berthId || !payload?.data?.cargoId) {
          state.error = " Invalid berth ID or cargo ID";
          return;
        }

        if (!state.operations || !state.operations[payload.berthId]) {
          return;
        }

        if (state.operations[payload.berthId]) {
          state.operations[payload.berthId] = state.operations[
            payload.berthId
          ]?.map((operation) => {
            if (operation.cargoId === payload?.data?.cargoId) {
              return { ...operation, ...action.payload?.data };
            }
            return operation;
          });
        }
      })
      .addCase(updateCargoData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(deleteCargoData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCargoData.fulfilled, (state, action) => {
        state.loading = false;
        // state.operations = state.operations.filter(
        //   (operation) => action.payload?.cargoId !== operation.cargoId
        // );
        // if (state.operations) {
        //   Object.keys(state.operations).forEach((berthId) => {
        //     state.operations![berthId] = state.operations![berthId].filter(
        //       (operation) => action.payload?.cargoId !== operation.cargoId
        //     );
        //   });
        // }
        const { payload } = action;
        if (!payload || !payload.berthId || !payload?.cargoId) {
          state.error = " Invalid berth ID or cargo ID";
          return;
        }

        if (!state.operations || !state.operations[payload.berthId]) {
          return;
        }

        if (state.operations[payload.berthId]) {
          state.operations[payload.berthId] = state.operations[
            payload.berthId
          ]!.filter((operation) => payload?.cargoId !== operation.cargoId);
        }
      })
      .addCase(deleteCargoData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(addCargoData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addCargoData.fulfilled, (state, action) => {
        state.loading = false;
        // state.operations = [action.payload, ...state.operations];
        // if (state.operations) {
        //   if (!state.operations[action.payload.berthId]) {
        //     state.operations[action.payload.berthId] = [];
        //   }
        //   state.operations[action.payload.berthId] = [
        //     action.payload,
        //     ...state.operations[action.payload.berthId],
        //   ];
        // }
        const { payload } = action;
        if (!payload) {
          return;
        }

        const berthId = payload?.berthId;
        if (!berthId) {
          state.error = "Invalid berth ID in response";
          return;
        }

        if (!state.operations) {
          state.operations = {};
        }

        const existingDeliveries = state.operations[berthId] || [];
        state.operations[berthId] = [payload.data, ...existingDeliveries];
      })
      .addCase(addCargoData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    builder
      .addCase(moveCargoData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(moveCargoData.fulfilled, (state, action) => {
        state.loading = false;
        // state.operations = state.operations.filter(
        //   (operation) => action.payload?.id !== operation.cargoId
        // );
        // if (state.operations) {
        //   Object.keys(state.operations).forEach((berthId) => {
        //     state.operations![berthId] = state.operations![berthId].filter(
        //       (operation) => action.payload?.id !== operation.cargoId
        //     );
        //   });
        // }
        const { payload } = action;
        const berthId = payload?.data?.currentBerthId;
        if (!payload || !berthId || !payload?.cargoId) {
          state.error = " Invalid berth ID or cargo ID";
          return;
        }

        if (!state.operations || !state.operations[berthId]) {
          return;
        }

        if (state.operations[berthId]) {
          state.operations[berthId] = state.operations[berthId]?.filter(
            (operation) => operation.cargoId !== payload?.cargoId
          );
        }
      })
      .addCase(moveCargoData.rejected, (state) => {
        state.loading = false;
        state.error = "Unknown error… Please try again";
      });

    addWebSocketCases(builder, "cargo", "operations");
  },
});

// export const { clearCargoes } = cargoSlice.actions;
export default cargoSlice.reducer;
